import { render, staticRenderFns } from "./financialreceivable.vue?vue&type=template&id=b649bedc&scoped=true"
import script from "./financialreceivable.vue?vue&type=script&lang=js"
export * from "./financialreceivable.vue?vue&type=script&lang=js"
import style0 from "./financialreceivable.vue?vue&type=style&index=0&id=b649bedc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b649bedc",
  null
  
)

export default component.exports